<template>
  <div v-if="numDevice != undefined">
    <vs-row vs-w="12">
      <vs-card
        :style="{
          'background-image':
            'url(' +
            require('@/assets/images/i-APC/bg_floor_' + (index + 1) + '.png') +
            ')',
          'background-size': 'cover',
          'background-position': 'center',
        }"
        class="content-card"
      >
        <div class="title">
          <div>
            <h1>{{ floor[index] }}</h1>
          </div>
          <vs-spacer></vs-spacer>
          <PopupScheduleSetting
            :numDevice="numDevice"
            :schedule_light="schedule_light"
            :schedule_breaker="schedule_breaker"
            :schedule_air="schedule_air"
            :floor="index"
          />
        </div>
      </vs-card>
    </vs-row>
    <vs-row vs-w="12">
      <!-- <vs-col vs-w="6" vs-sm="12" vs-xs="12"> -->
      <vs-col
        v-for="(item, i) in numDevice.light"
        :key="i"
        vs-w="4"
        vs-sm="12"
        vs-xs="12"
      >
        <LightControl :device_id="item" :schedule="schedule_light[i]" />
      </vs-col>
      <vs-col
        v-for="(item, i) in numDevice.breaker"
        :key="i"
        vs-w="4"
        vs-sm="12"
        vs-xs="12"
      >
        <BreakerControl :device_id="item" :schedule="schedule_breaker[i]" />
      </vs-col>
      <vs-col
        v-for="(item, i) in numDevice.air"
        :key="i"
        vs-w="4"
        vs-sm="12"
        vs-xs="12"
      >
        <AirControl :device_id="item" :schedule="schedule_air[i]" />
      </vs-col>
      <!-- </vs-col> -->
    </vs-row>
    <vs-row vs-w="12" v-if="numDevice.air.length > 0">
      <vs-card class="content-card">
        <vs-row>
          <vs-icon
            icon="device_thermostat"
            size="30px"
            bg="#E4F9E6"
            round
            color="#F7D225"
          ></vs-icon>
          <h4 class="mt-1 ml-2">Temperature & Humidity</h4>
          <vs-spacer></vs-spacer>
          <vs-select v-model="select1" width="120px" @change="upDateChart">
            <vs-select-item
              :key="index"
              :value="item"
              :text="item"
              v-for="(item, index) in options1"
            />
          </vs-select>
        </vs-row>
        <MultiLineChart
          v-if="temp_hum.labels.length > 0"
          :chartdata="temp_hum"
          :height="250"
          :color="['#ffc107', '#25A5E1']"
          class="mt-3"
        />
      </vs-card>
    </vs-row>
  </div>
</template>

<script>
import AirControl from "./AirControl.vue";
import LightControl from "./LightControl.vue";
import Chart from "../../components/chart.vue";
import MultiLineChart from "../MultiLineChart.vue";
import PopupScheduleSetting from "./PopupScheduleSetting.vue";
import BreakerControl from "./BreakerControl.vue";

export default {
  components: {
    LightControl,
    AirControl,
    Chart,
    MultiLineChart,
    PopupScheduleSetting,
    BreakerControl,
  },
  props: {
    numDevice: {
      type: Object,
      default: null,
    },
    schedule_light: {
      type: [Array, Object],
      default: [],
    },
    schedule_breaker: {
      type: [Array, Object],
      default: [],
    },
    schedule_air: {
      type: [Array, Object],
      default: [],
    },
  },
  data() {
    return {
      select1: "Day",
      options1: ["Day", "Week", "Month"],
      index: null,
      floor: ["1st Floor", "2st Floor", "3rd Floor", "4th Floor"],
      numLight: [false],
      numAir: [false, true],
      // numDevice: undefined,
      // schedule_light: undefined,
      // schedule_breaker: undefined,
      // schedule_air: undefined,

      temp_hum: { value: [], labels: [], tooltip_label: [] },
    };
  },
  mounted() {
    this.index = parseInt(this.$route.params.index);
    // this.numDevice = this.$store.getters["i_APC/numDevice"][this.index];
    // this.schedule_light =
    //   this.$store.getters["i_APC/schedule_light"][this.index];
    // this.schedule_breaker =
    //   this.$store.getters["i_APC/schedule_breaker"][this.index];
    // this.schedule_air = this.$store.getters["i_APC/schedule_air"][this.index];
    // console.log(this.numDevice);
    this.getTempHum();
  },
  methods: {
    upDateChart() {
      console.log(this.select1);
      this.getTempHum();
    },
    async getTempHum() {
      this.temp_hum = { value: [], labels: [], tooltip_label: [] };

      let time_end = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      let time_start;
      switch (this.select1) {
        case "Day":
          time_start = this.$moment().format("YYYY-MM-DD 00:00:00");
          break;
        case "Week":
          time_start = this.$moment(
            new Date().getTime() - 6 * 24 * 60 * 60 * 1000
          ).format("YYYY-MM-DD 00:00:00");
          break;
        case "Month":
          time_start = this.$moment(
            new Date().getTime() - 29 * 24 * 60 * 60 * 1000
          ).format("YYYY-MM-DD 00:00:00");
          break;

        default:
          time_start = this.$moment().format("YYYY-MM-DD 00:00:00");
          break;
      }
      console.log(time_start, time_end);
      let body = {
        floor: this.index + 1,
        start: time_start,
        end: time_end,
      };
      console.log(body);

      let res = await this.$API.post("tuya/graph/floor", body);
      console.log(res);

      if (res.status == 200) {
        let temp = [],
          hum = [],
          labels = [];

        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          temp.push(el.temp);
          hum.push(el.humid);
          labels.push(this.$moment(el.timestamp).format("DD-MM HH:mm"));
          // if (this.select1 == "Week" || this.select1 == "Month") {
          //   if (i % 24 == 0) {
          //     labels.push(this.$moment(el.timestamp).format("YYYY-MM-DD"));
          //   } else {
          //     labels.push("");
          //   }
          // } else {
          //   labels.push(this.$moment(el.timestamp).format("YYYY-MM-DD HH:mm"));
          // }
        }

        // this.temp_hum = { value: [], labels: [] ,tooltip_label:[]};

        this.temp_hum.value.push(temp);
        this.temp_hum.tooltip_label.push("Temperature ( °C )");

        this.temp_hum.value.push(hum);
        this.temp_hum.tooltip_label.push("Humidity ( % )");

        this.temp_hum.labels = labels;
      }
      console.log(this.temp_hum);
    },
  },
};
</script>

<style lang="scss" scoped>
.content-card {
  border-radius: 20px;
  // background: #6a15f3;
}
.title {
  display: flex;
  flex-direction: row;
}
.btn-icon {
  cursor: pointer;
}
</style>